<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item
            label="选择时间区间"
          >
            <a-range-picker v-decorator="['date']" class="search_content_class" :locale="locale"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            label="账户名"
          >
            <a-input
              v-decorator="['create_by_equal']"
              @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
              placeholder="请输入账户名"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10" class="submitBtnBox">
          <a-button type="primary" class="btnMar"  @click="getList({current:1,pageSize:pagination.pageSize})">
            查询
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <!-- <div class="title_class">
      <div class="title_search_class">
        <div class="search_change_class">
          <span class="text_class">选择时间区间:</span>
          <a-range-picker class="search_content_class" @change="onChange" :locale="locale"/>
        </div>
        <div class="search_change_class">
          <span class="text_class">员工姓名:</span>
          <a-input class="search_content_class" placeholder="请输入" ></a-input>
        </div>
      </div>
      <div class="title_btn_class">
        <a-button type="primary" class="search_class" @click="getList">查询</a-button>
        <a-button type="danger" ghost @click="resetFields">清空</a-button>
      </div>
    </div> -->
    <div class="content_class">
      <a-table
        ref="listRef" :scroll="{y,x: 1000}"
        class="tableBox"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :locale="locale"
      />
    </div>
  </div>
</template>
<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
const columns = [
  // {
  //   title: '序号',
  //   dataIndex: 'sort',
  // },
  {
    title: '操作时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作员',
    dataIndex: 'createBy',
  },
  // {
  //   title: '员工编号',
  //   dataIndex: 'one3',
  // },
  {
    title: '执行内容',
    dataIndex: 'logData',
  },
  // {
  //   title: '操作类型',
  //   dataIndex: 'option',
  // },
];
export default {
  data(){
    return{
      y: 500,
      form: this.$form.createForm(this, { name: 'OperationLog' }),
      locale,
      pagination: {
        total: 0,
        pageSize:20,
        current: 1,
        pageSizeOptions: ['10','20','30','40','50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.pagination.pageSize = pageSize
          this.getList()
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns,
      list: []
    }
  },
  created(){
    this.getList()
  },
  mounted(){
    this.y = this.$refs.listRef.$el.offsetHeight - 116
  },
  methods: {
    resetFields(){
      this.form.resetFields()
    },
    getList(pagination){
      let {current,pageSize} = pagination || this.pagination
      
      this.form.validateFields((err, values) => {
        let {date,create_by_equal} = values || {}
        let params = {
          current,
          size: pageSize,
          create_time_gt: date&&date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00'): undefined,
          create_time_lt: date&&date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          create_by_equal
        }
        this.$http.get('/iot-log/usual/list',{params}).then(res => {
          let {success,data} = res;
          if(success){
            let {records,current=1,total=0} = data;
            this.pagination.current = current
            this.pagination.total = total
            this.list = records || []
          }else{
            this.$message.error('查询失败')
          }
        })
      })
    },
    onChange(){},
    handleChange(){},
    addHandle(){},
    resetHandle(){},
  }
}
</script>
<style lang="scss" scoped>
  .listContent {
    height: calc(100% - 41px);
    border-radius: 5px;
    .title_class {
      background-color: #fff;
      margin-bottom: 21px;
      border-radius: 5px;
      padding: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .title_search_class {
        display: flex;
        flex-wrap: wrap;
        flex: 2;
        .search_change_class{
          display: flex;
          align-items: center;
          margin: 0 10px 10px 0;
          .text_class {
            width: 100px;
          }
        }
      }
      .title_btn_class {
        flex: 0.6;
        .search_class {
          margin-right: 10px;
        }
      }
    }
    .content_class {
      background-color: #fff;
      border-radius: 5px;
      // padding: 20px;
      height: calc(100% - 80px);
    }
  }
  .tableBox{
    height: 100%;
  }
</style>